export const GUARDED = 'guarded';
export const NORMAL = 'normal';